.indicator svg {
	color: #bf0033;
}

.indicator:focus-visible,
.indicator:focus {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 3px;
	border-radius: 2px;
}

.controlTooltipRow {
	display: flex;
	align-items: center;
	gap: 5px;
}
